"use strict";

var _slicedToArray = require("/var/www/ios-submodules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDownloadExcel = void 0;

var react_1 = require("react");

var lib_1 = require("../lib");

function useDownloadExcel(_ref) {
  var currentTableRef = _ref.currentTableRef,
      filename = _ref.filename,
      sheet = _ref.sheet;

  var _ref2 = (0, react_1.useState)({}),
      _ref3 = _slicedToArray(_ref2, 2),
      payload = _ref3[0],
      setPayload = _ref3[1];

  (0, react_1.useEffect)(function () {
    setPayload({
      currentTableRef: currentTableRef,
      filename: filename,
      sheet: sheet
    });
  }, [currentTableRef, filename, sheet]);
  return (0, react_1.useMemo)(function () {
    return (0, lib_1.excel)(payload);
  }, [payload]);
}

exports.useDownloadExcel = useDownloadExcel;